import {useRef} from "react";
import {getColumnSearchProps} from "../widget/SearchProps";
import {PlantStageType} from "../../api/Constants";
import {Link} from "react-router";
import {EmptyMetrcWidget} from "./EmptyMetrcWidget";
import {toFSDateTime} from "../../util/timeutils";
import {Checkbox, Table} from "antd";


export const PlantTable = ({plants, stage, roomMap, pagination, checked, setChecked}) => {
    const searchInput = useRef(null);

    const onCheck = (plantId) => () => {
        const nextChecked = {...checked};
        nextChecked[plantId] = (nextChecked[plantId]) ? false : true;
        if (setChecked) setChecked(nextChecked);
    }

    const columns = [];
    if (checked !== undefined) {
        columns.push({
            title: 'Select',
            key: 'select',
            dataIndex: 'id',
            render: (val, record) => {
                let select = checked[record.id] ? true : false;
                return <Checkbox checked={select} onClick={onCheck(record.id)} />
            }
        })
    }
    columns.push(
        {
            title: 'Name',
            key: 'name',
            dataIndex: 'name',
            ...getColumnSearchProps(`name`, searchInput),
            sorter: (a, b) => a.name.localeCompare(b.name),
            render: (val, record) => {
                if (stage === PlantStageType.Mom) {
                    return <Link to={`/cultivationapp/mom/${record.id}`}>{val}</Link>
                } else {
                    return <Link to={`/cultivationapp/plant/${record.id}`}>{val}</Link>
                }
            }
        },
        {
            title: 'Description',
            key: 'description',
            dataIndex: 'description',
            ...getColumnSearchProps(`description`, searchInput)
        },
        {
            title: 'Stage',
            key: 'stage',
            dataIndex: 'stage',
            render: (val, record) => {
                return PlantStageType.Label[val];
            }
        },
        {
            title: 'Location',
            key: 'location',
            dataIndex: 'roomId',
            render: (val, record) => {
                if ((val === undefined) || (val === null) || (roomMap === undefined)) {
                    return "None"
                }
                const room = roomMap[val];
                const {name} = room;
                return name;
            }
        }
    );
    if ((stage > PlantStageType.Mom) && (stage <= PlantStageType.Flower)) {
        columns.push({
            title: 'Count',
            key: 'count',
            dataIndex: 'currentCount',
        });
    }

    columns.push(
        {
            title: 'Metrc',
            key: 'metricTag',
            dataIndex: 'metricTag',
            ...getColumnSearchProps(`metricTag`, searchInput),
            sorter: (a, b) => a.metricTag.localeCompare(b.metricTag),
            render: (val, record, index) => {
                if ((val === null) || (val ==="")) {
                    return <EmptyMetrcWidget plantId={record.id} />
                } else {
                    return val;
                }
            }
        },
        {
            title: 'Created',
            key: 'creationTime',
            dataIndex: 'creationTime',
            render:(val) => {
                return toFSDateTime(new Date(val));
            },
            sorter: (a, b) => (new Date(a.creationTime))- (new Date(b.creationTime)),
        },
    );

    if (stage === PlantStageType.Destroyed) {
        columns.push({
            title: 'Destroyed',
            key: 'destructionTime',
            dataIndex: 'destructionTime',
            render:(val) => {
                if (val === null) {
                    return 'None'
                }
                return toFSDateTime(new Date(val));
            },
            sorter: (a, b) => (new Date(a.destructionTime))- (new Date(b.destructionTime)),
        });
    }

    return <Table dataSource={plants} columns={columns} pagination={pagination} />
}